import _ from 'lodash';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ListContainer from './list/ListContainer';
import ListEditContainer from './list/ListEditContainer';
import FileNotFound from './FileNotFound';

const paymentPages = ['APA1B', 'SMM6D'];

const List = ({ action = '', name, itemId = '', query = {}, page }) => {
  const branch = useSelector(state => state.app.branch);

  if (paymentPages.includes(name) && !_.get(branch, 'payment.enabled')) {
    return <FileNotFound message="This page requires additional configuration" />;
  }

  if (action === 'edit' || action === 'new' || action === 'copy') {
    return (
      <ListEditContainer
        action={action}
        itemId={decodeURIComponent(itemId)}
        itemName={name}
        namespace="list"
        page={page}
        query={query}
      />
    );
  }

  return <ListContainer page={page} name={name} query={query.q} />;
};

List.propTypes = {
  action: PropTypes.string,
  itemId: PropTypes.string,
  name: PropTypes.string,
  page: PropTypes.object,
  query: PropTypes.object,
};

export default List;
